<app-breadcrumb [title]="'Cartas'" [items]="['Vehiculos']" [active_item]="'Cartas'">
</app-breadcrumb>

<div class="container-fluid">
    <div class="card cartas-card">

        <!-- Encabezado -->
        <div class="card-header cartas-card-header d-flex align-items-center">
            <div>
                <h5 class="mb-1"><strong>Generar carta</strong></h5>
                <p class="mb-0">Completa los datos requeridos para preparar el documento PDF.</p>
            </div>
        </div>

        <div class="card-body cartas-card-body">

            <!-- 1. Documento y vehículo -->
            <section class="form-section">
                <div class="form-section-heading">
                    <span class="section-number">1</span>
                    <div>
                        <h6 class="mb-1">Documento y vehículo</h6>
                        <p class="mb-0">Selecciona el tipo de carta y el vehículo relacionado.</p>
                    </div>
                </div>

                <div class="row g-3">
                    <div class="col-12 col-md-6">
                        <label class="form-label" for="carta">Tipo de carta: <span class="required-mark">*</span></label>
                        <ng-select inputId="carta" [items]="Cartas" bindLabel="descripcion" bindValue="id"
                            appendTo="body" placeholder="Selecciona una carta"
                            [(ngModel)]="cartaSeleccionada" name="carta" required>
                        </ng-select>
                    </div>

                    <div class="col-12 col-md-6">
                        <label class="form-label" for="placa">Placa del vehículo: <span class="required-mark">*</span></label>
                        <ng-select inputId="placa" [items]="Placas" bindLabel="placa" bindValue="placa"
                            appendTo="body" placeholder="Selecciona una placa"
                            [(ngModel)]="placaSeleccionada" name="placa" required>
                        </ng-select>
                    </div>
                </div>
            </section>

            <!-- 2. Datos de la empresa (cartas 1, 6 y 7) -->
            <section class="form-section" *ngIf="requiereEmpresa">
                <div class="form-section-heading">
                    <span class="section-number">2</span>
                    <div>
                        <h6 class="mb-1">Datos de la empresa</h6>
                        <p class="mb-0">Indica el nombre y la ciudad que aparecerán en la carta.</p>
                    </div>
                </div>

                <div class="row g-3">
                    <div class="col-12 col-md-6">
                        <label class="form-label" for="nombreEmpresa">A quién va dirigida: <span class="required-mark">*</span></label>
                        <input id="nombreEmpresa" type="text" placeholder="Escribe el nombre de la empresa"
                            class="form-control" [(ngModel)]="nombreEmpresa" name="nombreEmpresa" required>
                    </div>

                    <div class="col-12 col-md-6">
                        <label class="form-label" for="ciudadEmpresa">Ciudad: <span class="required-mark">*</span></label>
                        <ng-select inputId="ciudadEmpresa" [items]="ciudad" bindLabel="MUNICIPIO" bindValue="MUNICIPIO"
                            appendTo="body" placeholder="Selecciona una ciudad"
                            [(ngModel)]="ciudadEmpresa" name="ciudadEmpresa" required>
                        </ng-select>
                    </div>
                </div>
            </section>

            <!-- 3. Detalle de participación (carta 7) -->
            <section class="form-section" *ngIf="esCartaParticipacion">
                <div class="form-section-heading">
                    <span class="section-number">3</span>
                    <div>
                        <h6 class="mb-1">Detalle de participación</h6>
                        <p class="mb-0">Completa el porcentaje y el valor correspondiente.</p>
                    </div>
                </div>

                <div class="row g-3">
                    <div class="col-12 col-md-6">
                        <label class="form-label" for="porcentajeEmpresa">Porcentaje: <span class="required-mark">*</span></label>
                        <div class="input-group">
                            <input id="porcentajeEmpresa" type="number" placeholder="Ej. 25" class="form-control"
                                [(ngModel)]="porcentajeEmpresa" name="porcentajeEmpresa" required>
                            <span class="input-group-text">%</span>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <label class="form-label" for="valorEmpresa">Valor: <span class="required-mark">*</span></label>
                        <input id="valorEmpresa" type="number" placeholder="Ingresa el valor" class="form-control"
                            [(ngModel)]="valorEmpresa" name="valorEmpresa" required>
                    </div>
                </div>
            </section>

            <!-- Acciones -->
            <div class="form-actions">
                <span class="required-hint"><span class="required-mark">*</span> Campo obligatorio</span>
                <button type="button" class="btn btn-danger generate-pdf-button" (click)="exportarPDF()"
                    [disabled]="formularioInvalido">
                    <i class="icofont icofont-file-pdf me-2"></i>
                    Generar PDF
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal de vista previa -->
<div class="modal fade" id="filePreviewModal" tabindex="-1" aria-labelledby="filePreviewModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-dark" id="filePreviewModalLabel">{{ previewFile?.name }}</h5>
                <button type="button" class="btn btn-outline-primary btn-sm ms-auto me-3" (click)="descargarPreview()">
                    <i class="icofont icofont-download me-1"></i>
                    Descargar
                </button>
                <button type="button" class="btn-close ms-0" data-bs-dismiss="modal" aria-label="Cerrar"></button>
            </div>
            <div class="modal-body p-0">
                <iframe *ngIf="previewFile?.type === 'pdf'" [src]="sanitizeUrl(previewFile?.url)" width="100%"
                    height="600px" title="Vista previa del documento PDF" frameborder="0"></iframe>
            </div>
        </div>
    </div>
</div>